// extracted by mini-css-extract-plugin
export default {"section":"Lu-z","inSectionButton":"Mu-z","addressCard":"Nu-z","disabled":"Ou-z","cautionBox":"Pu-z","failureBox":"Qu-z","fade-out":"Ru-z","successBox":"Su-z"};